module.exports = __webpack_public_path__ + "static/img/case8.b2eea6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceCase/case8.png
// module id = p36Z
// module chunks = 1